import Vue from 'vue';
import App from './App.vue';
import router from './router';
import HQObserver from '@/utils/webHQ';
import { webviewBounce } from '@/utils/tools';
import { syncFollow } from '@/utils/follow';
import '@atom/b2c-tokens/dist/variables_750_rem.css';
import { Dialog } from '@atom/atom-ui';
Vue.config.productionTip = false;
// 设置全局黑夜模式变量
Vue.prototype.$isBlack = window.getCssStyle() === 'black';
Vue.prototype.$dpr = parseInt(document.getElementsByTagName('html')[0].getAttribute('data-dpr'), 10);
// 消除滚动
webviewBounce();
Vue.use(window.hxmui, {
  // 注意这里替换成自己的项目名，请勿使用中文名
  projectName: 'research-report',
});
// 注册获取当前行情方法
Vue.use(HQObserver);
Vue.use(syncFollow);
Vue.use(Dialog);
// 支付组件
const hxmpay = window.getPlatform() === 'iphone' ? window.hxmpayThs : window.hxmpay;
Vue.use(hxmpay);
new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
